module.exports = __webpack_public_path__ + "static/media/pdf-512.80a6e8dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/pdf-512.png
// module id = 1492
// module chunks = 0